export const removeTagsAndSpaces = (input: string): string => {
  const withoutTags = input.replace(/<\/?[^>]+(>|$)/g, '');

  const withoutSpaces = withoutTags.replace(/\s+/g, '');
  return withoutSpaces;
};
